// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autofit-ellipsis[data-v-2d4db33f]{height:100%}", ""]);
// Exports
module.exports = exports;
